// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__DzgYr","additionalInfo":"AgreementModal_additionalInfo__2FXz6"};